module.exports = require("prismjs/components/prism-cpp.js");